import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icon/change-password.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "image-bottom mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-[134px] mx-auto",
    alt: "logo"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-extrabold mb-4" }, "Ubah Password", -1)
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "oldPassword",
  class: "label-text"
}, "Password Lama", -1)
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "newPassword",
  class: "label-text"
}, "Password Baru", -1)
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmNewPassword",
  class: "label-text"
}, "Ulangi Password Baru", -1)
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { class: "my-8" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Simpan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Password = _resolveComponent("Password")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ModalDefault, {
      show: _ctx.showDialog,
      onHideDialog: _ctx.hideDialog
    }, {
      content: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createVNode(_component_Form, {
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schemaValidation,
          "initial-values": _ctx.initialValues,
          class: "form-container"
        }, {
          default: _withCtx(({ errors, setFieldValue, values }) => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_Field, { name: "oldPassword" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_component_Password, _mergeProps({ class: "w-full" }, field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    id: "oldPassword",
                    feedback: false,
                    placeholder: "********",
                    toggleMask: "",
                    minlength: 8,
                    maxlength: 100,
                    class: `input-primary ${errors.oldPassword ? 'input-invalid' : ''}`
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_5, _toDisplayString(errors.oldPassword), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_Field, { name: "newPassword" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_component_Password, _mergeProps({ class: "w-full" }, field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    id: "newPassword",
                    feedback: false,
                    placeholder: "********",
                    toggleMask: "",
                    minlength: 8,
                    maxlength: 100,
                    class: `input-primary ${errors.newPassword ? 'input-invalid' : ''}`
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_8, _toDisplayString(errors.newPassword), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Field, { name: "confirmNewPassword" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_component_Password, _mergeProps({ class: "w-full" }, field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    id: "confirmNewPassword",
                    feedback: false,
                    placeholder: "********",
                    toggleMask: "",
                    minlength: 8,
                    maxlength: 100,
                    class: `input-primary ${errors.confirmNewassword ? 'input-invalid' : ''}`
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_11, _toDisplayString(errors.confirmNewPassword), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Button, {
                type: "submit",
                id: "Submit",
                class: "btn-primary w-full mr-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"])
      ]),
      _: 1
    }, 8, ["show", "onHideDialog"])
  ]))
}